import { Widget } from './Widget.js';
import { isWidgetCloseControl } from './WidgetCloseControl.js';

var _a;
/**
 * Глобальный контроллер, отвечающий за предупреждение пользователя
 * при закрытии/перезагрузке страницы, если какие-то виджеты
 * сообщили о несохранённых данных.
 */
class PageCloseController {
    /** Установить глобальный обработчик beforeunload (вешается один раз) */
    static install() {
        if (this.installed)
            return;
        window.addEventListener('beforeunload', this.onBeforeUnload);
        this.installed = true;
    }
    /** Снять глобальный обработчик beforeunload */
    static uninstall() {
        this.suppressed = false;
        if (!this.installed)
            return;
        window.removeEventListener('beforeunload', this.onBeforeUnload);
        this.installed = false;
    }
    /**
     * Отключает предупреждение до конца жизни страницы.
     * Вызывается перед переходом, который выполняет само приложение.
     */
    static suppress() {
        this.suppressed = true;
    }
    /** Возвращает предупреждение обратно (например, если переход не состоялся) */
    static release() {
        this.suppressed = false;
    }
    /**
     * Одноразовая проверка (например, перед внутренней навигацией в SPA).
     * Возвращает строку-предупреждение от первого попавшегося виджета
     * или null, если все виджеты готовы к закрытию.
     */
    static check() {
        if (this.suppressed)
            return null;
        for (const w of Widget.getAll()) {
            if (!isWidgetCloseControl(w))
                continue;
            try {
                const res = w.canClose();
                if (typeof res === 'string' && res.trim())
                    return res;
            }
            catch {
                // ошибки виджета не должны ломать глобальную проверку
            }
        }
        return null;
    }
}
_a = PageCloseController;
PageCloseController.installed = false;
/**
 * 2026-08-25: навигация, инициированная самим приложением (redirect или reload
 * из ответа сервера), не должна показывать предупреждение о несохранённых
 * данных: пользователь уже подтвердил действие кнопкой.
 */
PageCloseController.suppressed = false;
/**
 * Глобальный обработчик beforeunload.
 * Если check() вернуло сообщение → блокируем закрытие страницы.
 */
PageCloseController.onBeforeUnload = (e) => {
    const msg = _a.check() ?? null;
    if (!msg)
        return;
    e.preventDefault(); // для совместимости
    // TS6385: 'returnValue' помечено как deprecated,
    // но это до сих пор единственный способ вызвать стандартный диалог браузера.
    // Без этой строки событие просто проигнорируется.
    // eslint-disable-next-line deprecation/deprecation
    e.returnValue = msg;
    // ВАЖНО! На самом деле сообщение игнорируется и выводится только свое (браузерное)
    return msg; // возвращаем для старых браузеров
};

export { PageCloseController };
